// src/features/home/components/RotatingBadge.tsx

/**
 * Circular rotating badge used in the hero.
 * Larger size, tighter text rhythm, gold M monogram in center on deep green.
 */
export default function RotatingBadge() {
  return (
    <div className="absolute right-8 top-8 h-32 w-32 md:h-36 md:w-36">
      <svg viewBox="0 0 120 120" className="h-full w-full">
        {/* Outer badge circle */}
        <circle cx="60" cy="60" r="58" fill="#062018" />
        <circle
          cx="60"
          cy="60"
          r="54"
          fill="none"
          stroke="#c9a961"
          strokeOpacity="0.4"
          strokeWidth="0.5"
        />

        {/* Rotating text on a circular path */}
        <g
          className="origin-center animate-[spin_20s_linear_infinite]"
          style={{ transformOrigin: "center" }}
        >
          <defs>
            <path
              id="rotating-badge-path"
              d="M 60,60 m -44,0 a 44,44 0 1,1 88,0 a 44,44 0 1,1 -88,0"
            />
          </defs>
          <text
            fill="#ffffff"
            fontSize="9"
            fontFamily="Fraunces, serif"
            letterSpacing="4"
            fontWeight="500"
          >
            <textPath href="#rotating-badge-path" startOffset="0">
              BOOK NOW • STAY WITH US • BOOK NOW • STAY WITH US •
            </textPath>
          </text>
        </g>

        {/* Center M monogram (Fraunces-style) */}
        <text
          x="60"
          y="70"
          textAnchor="middle"
          fontFamily="Fraunces, serif"
          fontSize="28"
          fontWeight="500"
          fill="#c9a961"
        >
          M
        </text>
      </svg>
    </div>
  );
}